import { useState, FormEvent } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';

interface ChatInputProps {
  onSubmit: () => void;
}

export default function ChatInput({ onSubmit }: ChatInputProps) {
  const [value, setValue] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (value.trim()) {
      onSubmit();
      setValue('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      <div className="relative group">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-lovable-red/60 group-focus-within:text-lovable-red transition-colors">
          <Sparkles className="w-5 h-5" />
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Describe your website idea..."
          className="w-full pl-12 pr-14 py-4 text-base bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 shadow-lg text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-lovable-red/50 focus:border-lovable-red/50 transition-all"
        />
        <motion.button
          type="submit"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-gradient-to-r from-lovable-red to-lovable-teal hover:from-lovable-red/80 hover:to-lovable-teal/80 rounded-xl flex items-center justify-center text-white shadow-lg shadow-lovable-red/20 transition-all"
          aria-label="Submit"
        >
          <ArrowRight className="w-5 h-5" />
        </motion.button>
      </div>
    </form>
  );
}
